export default [
    // signup route with optional refererral link
    {
        path: '/get-started',
        name: 'signup',
        component: () => import(/* webpackChunkName: "join" */ '@/views/getstartView.vue'),
        meta: {
            layout: 'blank'
        }
    },
    // signup route with optional refererral link
    {
        path: '/get-started/confirm',
        name: 'signup.confirm',
        component: () => import(/* webpackChunkName: "join" */ '@/views/getstartconfirmView.vue'),
        meta: {
            layout: 'blank'
        }
    },
    // login form view
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/loginView.vue'),
        meta: {
            layout: 'blank'
        }
    }
];
